// extracted by mini-css-extract-plugin
export default {"footer":"f4594feb0dbedc83","button":"_955b69bb91779186"};